export default __webpack_public_path__ + "static/media/REL-DIN-16A.44d3b2bb.png";